import React, { useState } from 'react';
import './Experience.css';

const Experience = () => {
  const [expandedItems, setExpandedItems] = useState(new Set(['internship-0', 'freelancing-0']));

  const toggleItem = (index) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(index)) {
      newExpanded.delete(index);
    } else {
      newExpanded.add(index);
    }
    setExpandedItems(newExpanded);
  };

  const internships = [
    {
      title: 'Software Engineer Intern @ Yellow.ai',
      date: 'January 2026 – April 2026',
      details: 'Configured custom JSON payload action nodes and optimized conversational data pipelines within the cloud.yellow.ai platform, streamlining platform integrations and data routing logic.'
    },
    {
      title: 'Software Development Engineer Intern @ BlueStock Fintech',
      date: 'June 2025 – July 2025',
      details: 'Remote\n\nConducted financial data engineering and applied Machine Learning models to analyze stock market trends. Engineered an automated IPO allotment analytics tool handling backend data ingestion, transformation, and visual reporting.'
    },
    {
      title: 'Data Analyst Intern @ Unified Mentor',
      date: 'July 2024 – October 2024',
      details: 'Analyzed and processed multi-source client datasets, validating data accuracy, handling missing records, and structuring outputs into actionable executive Tableau presentations and KPI dashboards for management review.'
    },
    {
      title: 'Graphics & Web Design Intern @ Unnati Informatics LLP',
      date: 'June 2025 – July 2025',
      details: 'Designed structured web layouts and modified digital user interfaces using HTML and CSS, emphasizing clean hierarchy and user-centric data presentation.'
    }
  ];

  const freelancing = [
    {
      title: 'Data Analyst & Technical Consultant @ 7/12 Suvidha',
      date: 'August 2025 – August 2026',
      details: 'Commercial Property Network\n\nServed as the primary data analyst and reporting consultant across a 200+ property portfolio. Gathered business requirements directly from stakeholder teams and designed centralized digital dashboard tools that eliminated manual spreadsheet reconciliation bottlenecks.'
    },
    {
      title: 'Data Solutions Developer @ V K Engineers',
      date: 'November 2025 – December 2025',
      details: 'Ahmedabad, India\n\nEngineered an automated workforce reporting and payment tracking system. Structured attendance logs and built automated weekly summary reports for executive leadership oversight.'
    },
    {
      title: 'Web & Analytics Developer @ BioRise Chem',
      date: 'June 2025 – July 2025',
      details: 'Developed a corporate web presence with full Google Analytics 4 integration. Configured event tracking funnels and visitor traffic reports to identify geographic acquisition channels.'
    },
    {
      title: 'Digital Solutions Developer @ RESTART Mental Health Clinic',
      date: 'July 2025',
      details: 'Deployed a responsive digital platform for healthcare services, integrating automated inquiry routing and traffic monitoring.'
    }
  ];

  return (
    <div className="experience-container">
      <div className="experience-header-group">
        <span className="section-badge"><i className="fas fa-briefcase"></i> Career Journey</span>
        <h1>Professional Experience</h1>
        <p className="experience-subtitle">
          Industry internships, analytical consulting, and data engineering solutions delivered across diverse business sectors.
        </p>
      </div>

      <div className="categories-wrapper">
        <div className="internships-category">
          <h2><i className="fas fa-laptop-house"></i> Industry Internships</h2>
          {internships.map((item, index) => (
            <div key={index} className="experience-item">
              <div className="experience-header" onClick={() => toggleItem(`internship-${index}`)}>
                <div className="experience-title-wrapper">
                  <h3>{item.title}</h3>
                  <span className="experience-date">{item.date}</span>
                </div>
                <button className="expand-button" aria-label="Toggle details">
                  <i className={`fas ${expandedItems.has(`internship-${index}`) ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                </button>
              </div>
              <div className={`experience-description ${expandedItems.has(`internship-${index}`) ? 'active' : ''}`}>
                <p>{item.details}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="freelancing-category">
          <h2><i className="fas fa-chart-line"></i> Analytics & Consulting Projects</h2>
          {freelancing.map((item, index) => (
            <div key={index} className="experience-item">
              <div className="experience-header" onClick={() => toggleItem(`freelancing-${index}`)}>
                <div className="experience-title-wrapper">
                  <h3>{item.title}</h3>
                  <span className="experience-date">{item.date}</span>
                </div>
                <button className="expand-button" aria-label="Toggle details">
                  <i className={`fas ${expandedItems.has(`freelancing-${index}`) ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                </button>
              </div>
              <div className={`experience-description ${expandedItems.has(`freelancing-${index}`) ? 'active' : ''}`}>
                <p>{item.details}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
